import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-align-justify-icon',
  templateUrl: './text-align-justify.component.html'
})
export class TextAlignJustifyComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
